export const ok = (value) => ({ kind: 'ok', value });
export const err = (error) => ({ kind: 'err', error });
export const isOk = (r) => r.kind === 'ok';
export const isErr = (r) => r.kind === 'err';
export const unwrapOr = (r, fallback) => (isOk(r) ? r.value : fallback);
export const mapResult = (r, f) => isOk(r) ? ok(f(r.value)) : r;
//# sourceMappingURL=result.js.map